import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { MenuModule } from '@progress/kendo-angular-menu';
import { ButtonsModule } from '@progress/kendo-angular-buttons';

import { VerticalMenuComponent } from './vertical-menu.component';
import { VerticalMenuItemComponent } from './vertical-menu-item/vertical-menu-item.component';

const KENDO = [
	MenuModule,
	ButtonsModule
]

const BOOTSTRAP = [
	NgbDropdownModule,
	NgbTooltipModule
]

@NgModule({
	declarations: [
		VerticalMenuComponent,
		VerticalMenuItemComponent
	],
	imports: [
		CommonModule,
		TranslateModule,
		...BOOTSTRAP,
		...KENDO
	],
	exports: [
		VerticalMenuComponent,
		VerticalMenuItemComponent
	]
})
export class VerticalMenuModule {}
